/* eslint-disable @next/next/no-img-element */
import moment from "moment";
import { Visitor } from "@/graphql/generated/schema";
import { getDuration } from "../utils/visitiorUtils";
import VisitorStatusSelect from "../VisitorStatusSelect";
import { EyeOff, Laptop, Tablet } from "lucide-react";
import { twMerge } from "tailwind-merge";
import { TFunction } from "i18next";

export const visitorColumns = (
  onStatusChange: (id: string, newStatus: string) => void,
  theme: string,
  t: TFunction,
) => [
  {
    id: "status",
    header: t("visitors.columns.status"),
    accessor: "signedType",
    render: (value: string, row: Visitor) => (
      <>
        {row.anonymize ? (
          <EyeOff size={30} />
        ) : (
          <div className="flex flex-col items-center w-16 py-1">
            <div
              className={twMerge(
                "w-15 h-15 rounded-full overflow-hidden border shadow-sm transition-colors mt-2",
                theme === "dark" ? "border-gray-800" : "border-gray-300",
              )}
            >
              <img
                src={row.img || "/Avatar.svg"}
                alt="Profile"
                className="w-full h-full object-cover"
              />
            </div>

            <VisitorStatusSelect
              value={value}
              onChange={(newStatus) => onStatusChange(row.id || "", newStatus)}
            />
          </div>
        )}
      </>
    ),
  },
  {
    id: "visitor",
    header: t("visitors.columns.visitor"),
    accessor: "data",
    render: (value: any, row: Visitor) =>
      row.anonymize ? "Anonymized Visitor" : value?.fullName || "-",
    sortable: true,
  },
  {
    id: "host",
    header: t("visitors.columns.host"),
    accessor: "department",
    render: (_: any, row: any) =>
      row?.department?.name
        ? row.department?.name
        : `${row.employees?.[0]?.firstName || ""} ${
            row.employees?.[0]?.lastName || "-"
          }` || "-",
  },
  {
    id: "category",
    header: t("visitors.columns.category"),
    accessor: "category",
    render: (value: any) => value?.name || "-",
    sortable: true,
  },
  {
    id: "location",
    header: t("visitors.columns.location"),
    accessor: "location",
    render: (value: any) => value?.name || "-",
    sortable: true,
  },
  {
    id: "signedIn",
    header: t("visitors.columns.signedIn"),
    accessor: "signedIn",
    render: (v: any, row: any) => {
      return (
        <>
          {row.signedIn ? (
            <div className="flex items-center gap-2">
              <p>{row?.signedInDevice === "Web" ? <Laptop /> : <Tablet />}</p>
              <p>{moment(row?.signedIn).format("h:mma, MMM Do")}</p>
            </div>
          ) : (
            "-"
          )}
        </>
      );
    },
    sortable: true,
  },
  {
    id: "signedOut",
    header: t("visitors.columns.signedOut"),
    accessor: "signedOut",
    render: (v: any, row: any) => {
      return (
        <>
          {row.signedOut ? (
            <div className="flex items-center gap-2">
              <p>{row?.signedOutDevice === "Web" ? <Laptop /> : <Tablet />}</p>
              <p>
                {row?.signedOut
                  ? moment(row?.signedOut).format("h:mma, MMM Do")
                  : "-"}
              </p>
            </div>
          ) : (
            "-"
          )}
        </>
      );
    },
    sortable: true,
  },
  {
    id: "duration",
    header: t("visitors.columns.duration"),
    render: (_: any, row: any) => getDuration(row.signedIn, row.signedOut),
  },
];
